import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: true,
  styleUrls: ['./header.component.scss'],
  imports: [
    MatToolbarModule,
    MatButtonModule,
    RouterLink,
    MatIconModule,
    CommonModule
  ]
})
export class HeaderComponent implements OnInit, AfterViewInit {
  loginStatus: any;
  currentYear: any;
  @Input() scrolled = false;
  isMenuOpen = false;

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  constructor(private router: Router) {
    this.loginStatus = localStorage.getItem('self');
  }

  ngOnInit(): void {

    this.currentYear = new Date().getFullYear();
  }

  ngAfterViewInit() {
    // Intersection Observer to detect when hero section leaves the viewport
    const observer = new IntersectionObserver(
      ([entry]) => {
        this.scrolled = !entry.isIntersecting;
      },
      { threshold: 0 }
    );

    const hero = document.querySelector('#heroSection'); // or any top element
    if (hero) observer.observe(hero);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    console.log('WINDOW scroll fired');
    const y =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.scrolled = y > 200;
    console.log('scroll Y:', y, 'scrolled:', this.scrolled);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
    console.log('Menu state:', this.isMenuOpen);
  }

  goTo(url: string) {
    this.router.navigateByUrl(url);
  }

  openUrl(url: string) {
    window.open(url, '_blank');
  }
}
